import { useLocation } from '@xing-com/crate-core-router';

export const useIsWebview = () => {
  const location = useLocation();

  const isWebview = /^\/pages\/webview/.test(location.pathname);

  return isWebview;
};
